import resolveDb from "../db";
import { DbInstance, SYS_PARTITION_KEY } from "../utils/constants";

const db = resolveDb(DbInstance.JSON_DB);

export async function loadSystems() {
	const result = await db.find((key) => key.startsWith(SYS_PARTITION_KEY));

	return result;
}

export async function deleteSystem(sysId: string) {
	const system: any = await db.get(sysId, SYS_PARTITION_KEY);
	await db.delete(sysId, SYS_PARTITION_KEY);
	return system?.name;
}
